import { UnitDetailsPage } from '@apps-common/apps/portal/pages/units/pages/manage/pages/details/Index'

export const UnitDetailsModify = () => <UnitDetailsPage />
